// extracted by mini-css-extract-plugin
export var dropdownButton = "_3k-0";
export var fullWidthDropdownButton = "_3k-1";
export var icon = "_3k-3";
export var iconPlaceholder = "_3k-2";
export var menuItemRow = "_3k-9";
export var separator = "_3k-e";
export var shortcutContainer = "_3k-7";
export var shortcutContainerFilled = "_3k-8";
export var shortcutIconLg = "_3k-6";
export var shortcutIconMd = "_3k-5";
export var shortcutIconSm = "_3k-4";
export var submenuChevron = "_3k-d";
export var submenuDropdown = "_3k-a";
export var submenuTriggerRow = "_3k-b";
export var submenuTriggerRowOpen = "_3k-c";